export default __webpack_public_path__ + "static/home-card-women-founders-and-makers-8ea9e88d0a80d99ac59437e1709a280c.svg";